import Vue from "vue";
import Vuex, { createLogger } from "vuex";

import login from "./login";
import media from "./media";
import tree from "./tree";
import user from "./user";
import property from "./property";
import tests from "./tests";
import diagnosticTest from "./diagnosticTest";
import patient from "../views/LK/Patients/Store/index";
import createDiagnosticTest from "../views/LK/TestTasks/Store/index";
import takeDiagnosticTest from "../views/LkStudents/DiagnosticTest/Store/index";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    sideMenu: false,
    api: "https://apivpdevguid.nitrosbase.com/",
    apiGuide: "https://apibookvpnb.nitrosbase.com/",
    apiImg: "https://apivpdevguid.nitrosbase.com",
    apiPdf: "https://vp.sechenov.ru/docs/",
  },
  getters: {
    apiUrl: (state) => state.api,
    apiPdf: (state) => state.apiPdf,
    apiImg: (state) => state.apiImg,
    apiGuide: (state) => state.apiGuide,
    getSideMenu: (state) => state.sideMenu,
  },
  mutations: {
    setSideMenu(state, val) {
        state.sideMenu = val;

        // console.log('setSideMenu', state.sideMenu);
    },
  },
  modules: {
    login: login,
    media: media,
    user: user,
    tree: tree,
    property: property,
    tests,
    patient,
    createDiagnosticTest,
    takeDiagnosticTest,
    diagnosticTest
  }
});
